import clsx from 'clsx';

import { FILTER_LABEL_CLASS } from '@/shared/components/forms/FilterSelect';

export interface ISegmentedOption<T extends string = string> {
  value: T;
  label: string;
}

export interface ISegmentedControlProps<T extends string = string> {
  options: ISegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  label?: string;
  className?: string;
  bordered?: boolean;
}

const tabBtnClass = (active: boolean) =>
  clsx(
    'px-3 py-2 text-sm font-semibold border transition-colors cursor-pointer',
    active
      ? 'bg-theme-500 border-theme-500 text-white'
      : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-50'
  );

const SegmentedControl = <T extends string>({
  options,
  value,
  onChange,
  label,
  className,
  bordered = false,
}: ISegmentedControlProps<T>) => (
  <div className={className}>
    {label ? <span className={FILTER_LABEL_CLASS}>{label}</span> : null}
    <div
      className={clsx(
        'inline-flex rounded-md overflow-hidden',
        bordered && 'border border-gray-200 bg-white'
      )}
      role='group'
    >
      {options.map((option, index) => {
        const isFirst = index === 0;
        const isLast = index === options.length - 1;
        const isActive = value === option.value;

        return (
          <button
            key={option.value}
            type='button'
            className={clsx(
              tabBtnClass(isActive),
              !isFirst && 'border-l-0',
              isFirst && 'rounded-l-md',
              isLast && 'rounded-r-md'
            )}
            onClick={() => onChange(option.value)}
            aria-pressed={isActive}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  </div>
);

export default SegmentedControl;
